import { defineComponent as _defineComponent } from 'vue';
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useInvoiceListStore } from "@js/vue/domain/invoice/stores/useInvoiceListStore";
import Pagination from '../../../../components/ui/Pagination.vue';
import InvoiceExportButton from "../shared/InvoiceExportButton.vue";
import BrandBalanceAlert from "../shared/BrandBalanceAlert.vue";
import InvoiceFilters from './InvoiceFilters.vue';
import InvoiceTable from './InvoiceTable.vue';
import { Tooltip } from 'bootstrap';
import { useUserStore } from "@js/vue/domain/user/stores/useUserStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'InvoiceListLayout',
    setup(__props, { expose: __expose }) {
        __expose();
        const userStore = useUserStore();
        const invoiceListStore = useInvoiceListStore();
        const { filters, error, invoices, isLoading, paginationData, isUserRestricted } = storeToRefs(invoiceListStore);
        const { fetchInvoices, setPage, setPerPage } = invoiceListStore;
        const tooltipRef = ref(null);
        let tooltipInstance = null;
        watch(tooltipRef, (el) => {
            //@ts-ignore
            tooltipInstance?.dispose();
            tooltipInstance = null;
            if (el) {
                tooltipInstance = new Tooltip(el);
            }
        });
        onMounted(() => {
            fetchInvoices();
        });
        onUnmounted(() => {
            //@ts-ignore
            tooltipInstance?.dispose();
        });
        const __returned__ = { userStore, invoiceListStore, filters, error, invoices, isLoading, paginationData, isUserRestricted, fetchInvoices, setPage, setPerPage, tooltipRef, get tooltipInstance() { return tooltipInstance; }, set tooltipInstance(v) { tooltipInstance = v; }, Pagination, InvoiceExportButton, BrandBalanceAlert, InvoiceFilters, InvoiceTable };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
